import { render, staticRenderFns } from "./creditors.vue?vue&type=template&id=51ad8272&"
import script from "./creditors.vue?vue&type=script&lang=js&"
export * from "./creditors.vue?vue&type=script&lang=js&"
import style0 from "./creditors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports